/**
 * @file 支店データを提供します。
 * @description 支店、インハウスの2つのカテゴリに分類された支店名のリストを定義しています。
 *              このデータは、支店選択モーダルなどで使用されます。
 */

export const allBranchesData = {
  branches: [
    '札幌 第1支店',
    '札幌 第2 支店',
    '札幌 第3支店',
    '千歳支店',
    '仙台第1支店',
    '仙台第2支店',
    '郡山支店',
    '山形支店',
    '古河支店',
    '筑西支店',
    'つくば第1支店',
    'つくば第2支店',
    '水戸第1支店',
    '水戸第2支店',
    '久喜支店',
    '長岡支店',
    '新潟第1支店',
    '新潟第2支店',
    '高崎支店',
    '伊勢崎支店',
    '足利支店',
    '熊谷第1支店',
    '熊谷第2支店',
    'さいたま支店',
    '所沢支店',
    '清原支店',
    '那須ファクトリー支店',
    '小山ファクトリー支店',
    '宇都宮インダストリアル支店',
    '宇都宮ロジスティクス支店',
    '栃木第1支店',
    '栃木第2支店',
    '栃木第3支店',
    '栃木ジョブセンター',
    '立川支店',
    '横浜第1支店',
    '横浜第2支店',
    '横浜第3支店',
    '厚木支店',
    '東京ベイ支店',
    '千葉支店',
    '船橋支店',
    '静岡支店',
    '名古屋第1支店',
    '名古屋第2支店',
    '名古屋第3支店',
    '四日市支店',
    '高松支店',
    '松山支店',
    '広島支店',
    '京都支店',
    '大阪第1支店',
    '大阪第2支店',
    '大阪第3支店',
    '神戸支店',
    '北九州支店',
    '福岡第1支店',
    '福岡第2支店',
    '福岡第3支店',
    '熊本支店',
    '宮崎支店',
    '鹿児島支店',
    '東京第1営業部 第1支店',
    '東京第1営業部 第2支店',
    '東京第1営業部 第3支店',
    '東京第1営業部 第4支店',
    '東京第1営業部 第5支店',
    '東京第1営業部 第6支店',
    '東京第2営業部',
  ],
  offices: [
    'D&Mホールディングスオフィス',
    'アルプスアルパインオフィス',
    'ソニー・ミュージックソリューションズ茨城オフィス',
    'ソニー・ミュージックソリューションズ静岡オフィス',
    '東芝デバイス＆ストレージオフィス',
    '三菱重工パワー精密鋳造オフィス',
    'パナソニック宇都宮オフィス',
    'パナソニック山形オフィス',
    'EL APSCオフィス',
    '坂角総本舗オフィス',
    'SII仙台オフィス',
    'SIIクリスタルテクノロジーオフィス',
    'パナソニック住宅設備オフィス',
    'パイロットコーポレーション伊勢崎オフィス',
    'Parker TAIYOオフィス',
    'JAうつのみやオフィス',
    '東北電力ネットワークオフィス',
    '東北電力オフィス',
    'P&Gオフィス',
    'キャノンメディカルシステムズオフィス',
    '宮城ニコンプレシジョンオフィス',
    'コダックオフィス',
    '太陽誘電玉村オフィス',
    'JP楽天ロジスティクス習志野オフィス',
    'JP楽天ロジスティクス市川オフィス',
    'JP楽天ロジスティクス多摩オフィス',
    'JP楽天ロジスティクス大阪オフィス',
    'アクセンチュア東京オフィス',
    'アクセンチュア福岡オフィス',
    'アマゾン',
    'ラージアカウントOPs1 第1オフィス',
    'ラージアカウントOPs1 第2オフィス',
    'ラージアカウントOPs1 第3オフィス',
    'ラージアカウントOPs1 第4オフィス',
    'ラージアカウントOPs1 第5オフィス',
    'ラージアカウントOPs1 第6オフィス',
    'ラージアカウントOPs1 第7オフィス',
    'ラージアカウントOPs1 第8オフィス',
    'ラージアカウントOPs2 第1オフィス',
    'ラージアカウントOPs2 第2オフィス',
    'ラージアカウントOPs2 第3オフィス',
    'ラージアカウントOPs2 第4オフィス',
    'ラージアカウントOPs2 第5オフィス',
    'ラージアカウントOPs2 第6オフィス',
    'ラージアカウントOPs2 第7オフィス',
    'ラージアカウントOPs2 第8オフィス',
    'ラージアカウントOPs3 第1オフィス',
    'ラージアカウントOPs3 第2オフィス',
    'ラージアカウントOPs3 第3オフィス',
    'ラージアカウントOPs3 第4オフィス',
    'ラージアカウントOPs4 第1オフィス',
    'ラージアカウントOPs4 第2オフィス',
    'ラージアカウントOPs4 第3オフィス',
    'ラージアカウントOPs4 第4オフィス',
    'ラージアカウントOPs4 第5オフィス',
    'ラージアカウントOPs5 第1オフィス',
    'ラージアカウントOPs5 第2オフィス',
    'ラージアカウントOPs5 第3オフィス',
    'ラージアカウントOPs5 第4オフィス',
    'ラージアカウントOPs5 第5オフィス',
    'ラージアカウントOPs5 第6オフィス',
    'ラージアカウントOPs6 第1オフィス',
    'ラージアカウントOPs6 第2オフィス',
    'ラージアカウントOPs6 第3オフィス',
    'ラージアカウントOPs6 第4オフィス',
    'ラージアカウントOPs6 第5オフィス',
    'ラージアカウントOPs6 第6オフィス',
    'ラージアカウントOPs6 第7オフィス',
    'ラージアカウントOPs6 第8オフィス',
    'ラージアカウントOPs6 第9オフィス',
    'ラージアカウントOPs6 第10オフィス',
    'ラージアカウントOPs6 第11オフィス',
  ],
  drBranches: [
    'ドライバーユニット 北関東支店',
    'ドライバーユニット 埼玉支店',
    'ドライバーユニット 東京・千葉支店',
    'ドライバーユニット 神奈川支店',
    'ドライバーユニット 名阪支店',
  ],
};

export type BranchCategory = 'branches' | 'offices';
